<template>
  <div>
    <user-warning-message
      :users="[{
        id: demandeIntervention.demandeurId,
        msg: 'utilisateur.warning.demandeurArchive'
      }]"/>
    <infos-generales :demande-intervention="demandeIntervention"
                     class="mgb-20px mgt-20px">
    </infos-generales>
    <info-commande class="mgb-20px mgt-20px"
      v-if="demandeIntervention.ligneCommandeId"
      :ligne-commande="demandeIntervention.ligneCommande">
    </info-commande>
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="card contactEdition">
          <div class="header-card">
            <p>
              {{ $t('detailIntervention.infoGenerale.sujetDemande') }}
            </p>
          </div>
          <div class="card-content">
            <b-field
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ demandeIntervention.actionLogistique }}
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="card contactEdition">
          <div class="header-card">
            <p>
              {{ $t('detailIntervention.infoGenerale.description') }}
            </p>
          </div>
          <div class="card-content">
            <b-field
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ demandeIntervention.description }}
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="card contactEdition">
          <div class="header-card">
            <p>
              {{ $t('detailIntervention.infoGenerale.adresse') }}
            </p>
          </div>
          <div class="card-content">
            <detail-adresse class="has-text-weight-bold"
                :adresse="demandeIntervention.adresse"
                v-if="demandeIntervention.adresse.adresse1">
            </detail-adresse>
            <div v-else class="card-article-any has-background-background">
              <div class="card-content has-text-centered">
                <br>
                <h1 class="title is-size-4">
                  {{ $t('detailIntervention.noAdresse')}}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('piecesJointes.attachments')}}
            </p>
          </header>
          <div class="card-content">
            <pieces-jointes readOnly
                                deletable
                                autoSave
                                :checkPermissions=checkPermissions(constantes.INTERVENTION.maj)
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { INTERVENTION } from '@/configuration/logistique/permissionsLogistiqueConf';
import PiecesJointes from '@/components/general/piecesJointes';
import infosGenerales from '@/components/logistique/intervention/detail/infosGenerales';
import infoCommande from '@/components/logistique/intervention/detail/infoCommande';
import adresseConsultation from '@/components/general/adresseConsultation';
import userWarningMessage from '@/components/commun/user/userWarningMessage';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'demande_details_informations',
  props: {
    demandeIntervention: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        INTERVENTION,
      },
    };
  },
  components: {
    PiecesJointes,
    infosGenerales,
    detailAdresse: adresseConsultation,
    userWarningMessage,
    infoCommande,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};

</script>
